import Modal from '@/components/modals/modal/modal.vue'
import PaymentGroupOrders from '@/pages/collect-orders/components/payment-group-orders/payment-group-orders.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import emitHideMixin from '@/components/modals/mixins/emit-hide'
import { getShortId } from '@/utils/format-strings'


export default {
  name: 'NotAcceptedOrdersModal',

  /**
   * emitHideMixin - методы hide и onHideModal
   */
  mixins: [ emitHideMixin ],

  props: {
    routeTaskData: {
      type: Object
    }
  },

  components: {
    Modal,
    PaymentGroupOrders,
    ValidationObserver,
    ValidationProvider
  },

  data() {
    return {
      form: {
        comment: ''
      }
    }
  },

  methods: {
    getShortId,
    
    show () {
      this.form.description = ''
      this.$refs.modal.show()
    },

    onSubmit() {
      this.$refs['observer'].validate().then(async success => {
        if (success) {
          this.$emit('send', {
            routeTask: this.routeTaskData,
            sendData: {
              ...this.form
            }
          })
          this.hide()
        }
      })
    }
  }
}